import React, { useEffect, useRef } from 'react';
import { withScript } from '../../utils/network/useScript';
import * as styles from './CreditCardInput.module.scss';

interface CreditCardInputProps {
  onBind: (cb?: () => Promise<stripe.TokenResponse>) => void;
  onChange: stripe.elements.handler;
}

const CreditCardInput = ({
  onBind,
  onChange = () => {},
}: CreditCardInputProps) => {
  const elementContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!elementContainerRef.current) {
      return undefined;
    }
    const { Stripe } = window;
    const computedStyle = getComputedStyle(elementContainerRef.current);
    const getStyleValue = (name: string) =>
      computedStyle.getPropertyValue(name);

    const stripe = Stripe(window.__slab.STRIPE_PUBLISHABLE_KEY);
    const elements = stripe.elements();
    const card = elements.create('card', {
      style: {
        base: {
          backgroundColor: getStyleValue('--color-form-input-bg'),
          color: getStyleValue('--color-fg-default'),
          fontFamily: getStyleValue('font-family'),
          fontWeight: getStyleValue('font-weight'),
          iconColor: getStyleValue('--color-fg-muted'),
          letterSpacing: getStyleValue('letter-spacing'),
          '::placeholder': {
            color: getStyleValue('--color-fg-muted'),
          },
        },
        invalid: {
          color: getStyleValue('--color-danger-default'),
          iconColor: getStyleValue('--color-danger-default'),
        },
      },
    });
    card.mount(elementContainerRef.current);

    // Pass References to Parent
    onBind(() => stripe.createToken(card));
    card.addEventListener('change', onChange);

    return () => {
      onBind(undefined);

      // @ts-expect-error Method not specified in types
      card.removeEventListener('change', onChange);
      card.unmount();
      card.destroy();
    };
  }, [onBind, onChange]);

  return (
    <div className={styles.cardInput}>
      <div ref={elementContainerRef} />
    </div>
  );
};

export default withScript('https://js.stripe.com/v3/')(CreditCardInput);
